import { ExpectedTractorState } from "./ExpectedTractorState";
import { Section } from "portal/components/map/navigation/Section";
import { SetTractorStateTask } from "protos/rtc/jobs";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

interface SetTractorStateInfoProps {
  setTractorState: SetTractorStateTask;
}
export const SetTractorStateInfo: FC<SetTractorStateInfoProps> = ({
  setTractorState,
}) => {
  const { t } = useTranslation();

  return (
    <Section header={t("models.autotractor.taskTypes.tractorState")}>
      <div className="px-4 py-2 flex flex-col gap-1">
        <ExpectedTractorState states={setTractorState.state} />
      </div>
    </Section>
  );
};
